import { isEqual, memoize, noop } from "lodash"
import { Observable, distinctUntilChanged, shareReplay, switchMap } from "rxjs"
import { accountWebsocket } from "../websockets"

export type AssetBalance = {
  // https://github.com/alexgo-io/alex-stxdx-backend/blob/bc1d1e4578dd4ac089a666c60b4361df4da54cba/packages/api/controllers/account.controller.ts#L126-L162
  // balance of `[the asset settled on the blockchain] - [outgoing funds of all matched but not settled orders]`
  balance: string
  // incoming funds that is currently waiting for settlement on the blockchain
  incoming: string
  // amount that occupied by open orders
  locked: string
  // requested amount to withdraw
  withdraw: string

  // https://github.com/alexgo-io/alex-stxdx-backend/blob/bc1d1e4578dd4ac089a666c60b4361df4da54cba/packages/api/gateways/account.gateway.ts#L46-L47
  // balance + incoming - locked - withdraw
  available: string
}

export type AssetBalances = { [assetId: string]: AssetBalance }

export const getUserBalances = memoize(
  (jwt: string): Observable<AssetBalances> =>
    accountWebsocket.pipe(
      switchMap(
        socket =>
          new Observable<AssetBalances>(sink => {
            socket.emit("watch", { token: jwt })
            socket.onAny((name: string, data: AssetBalances) => {
              if (name === "balance") {
                sink.next(data)
              }
            })
            return noop
          }),
      ),
      shareReplay(1),
      distinctUntilChanged(isEqual),
    ),
)
